import React, { lazy } from 'react';
import { CheckCircleIcon, ShieldCheckIcon } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/krdKMAz2uQWQ5ReMLe6Ams/hf_20260314_213244_d0b72b8f-fc61-4e86-a223-ddccd3c06a65.jpg';
export function ProductReveal() {
  return <section className="py-8 md:py-20 px-4 bg-white border-t border-gray-200" data-id="element-231">
      <div className="max-w-4xl mx-auto text-center" data-id="element-232">
        <p className="text-success-green font-bold text-sm md:text-base tracking-widest uppercase mb-2" data-id="element-233">
          TE PRESENTO...
        </p>

        <h2 className="text-3xl md:text-6xl font-heading font-extrabold text-brown-dark mb-3 md:mb-6 drop-shadow-sm" data-id="element-234">
          Las 30 Recetas de Flanes que Facturan
        </h2>

        <p className="text-base md:text-2xl text-gray-700 font-medium mb-4 md:mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-235">
          El sistema completo para hacer, presentar y vender flanes sin horno
          desde tu casa — y tener dinero en el bolsillo este mismo fin de
          semana.
        </p>

        <div className="max-w-lg mx-auto mb-5 md:mb-10" data-id="element-236">
          <div className="p-[5px] rounded-2xl bg-gradient-to-br from-amber-400 via-yellow-500 to-amber-700 shadow-[0_0_30px_rgba(217,170,60,0.4)]" data-id="element-237">
            <div className="rounded-xl overflow-hidden" data-id="element-238">
              <img src={PRODUCT_IMAGE} alt="Las 30 Recetas de Flanes que Facturan" className="w-full h-auto object-cover max-h-[280px] md:max-h-none" width={600} height={400} loading="lazy" data-id="element-239" />
            </div>
          </div>
        </div>

        <div className="max-w-2xl mx-auto mb-5 md:mb-10" data-id="element-240">
          <div className="border-l-[3px] border-cta-green bg-green-50/50 rounded-[10px] p-4 md:p-6 text-left space-y-3 md:space-y-6" data-id="element-241">
            <p className="text-base md:text-xl text-gray-700 font-medium leading-relaxed" data-id="element-242">
              Es el único método organizado por rentabilidad, no por dificultad.
            </p>
            <p className="text-base md:text-xl text-gray-700 font-medium leading-relaxed" data-id="element-243">
              Cada receta incluye el coste real de los ingredientes, el precio
              de venta recomendado y el margen de beneficio que puedes esperar.
            </p>
            <p className="text-lg md:text-2xl font-bold text-green-800 text-center pt-2" data-id="element-244">
              No es solo un recetario. Es un negocio listo para arrancar.
            </p>
          </div>
        </div>
      </div>
    </section>;
}